import { v4 as uuidv4 } from 'uuid';
import CryptoJS from 'crypto-js';

export const uploadPhoto = async (photo, token) => {
  const originalFileName = photo.name;
  const fileExtension = photo.type.replaceAll('image/', '.');
  const uuidFileName = `${uuidv4()}web-ui${fileExtension}`;
  const blob = photo.slice(0, photo.size, photo.type);
  const newFile = new File([blob], uuidFileName, { type: photo.type });
  
  // Calculate MD5 hash BEFORE requesting pre-signed URL so backend can sign it
  const arrayBuffer = await newFile.arrayBuffer();
  const wordArray = CryptoJS.lib.WordArray.create(arrayBuffer);
  const md5Hash = CryptoJS.MD5(wordArray);
  const contentMD5 = CryptoJS.enc.Base64.stringify(md5Hash);
  
  // Pass MD5 to backend so it can include it in the pre-signed URL signature
  const generatedUrl = `https://${process.env.REACT_APP_API_SUBDOMAIN}.pge-811.com/ticketphoto?filename=${uuidFileName}&urlType=put&ContentMD5=${encodeURIComponent(contentMD5)}`;

  const headers = new Headers({
    Authorization: `Bearer ${token}`,
  });

  const preflightResponse = await fetch(generatedUrl, {
    method: 'GET',
    headers,
  });
  const preSignedUrl = await preflightResponse.text();
  
  const putResponse = await fetch(preSignedUrl, {
    method: 'PUT',
    headers: {
      'Content-Type': photo.type,
      'Content-MD5': contentMD5,
    },
    body: newFile,
  });
  if (putResponse.ok) {
    return {
      displayName: originalFileName,
      original: uuidFileName,
      thumbnail: uuidFileName,
    };
  }
  throw new Error('error');
};